import React from "react";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import { Link } from "react-router-dom";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableSortLabel,
  TablePagination,
  Icon,
  MenuItem,
  Checkbox,
  Select,
  InputLabel,
  Box,
  FormGroup,
  FormControl,
  IconButton,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  Tooltip,
} from "@material-ui/core";
import {
  PER_PAGE_OPTIONS,
  DEFAULT_PER_PAGE_RECORDS,
} from "__helpers/constants";
import {
  Button,
  Slide,
} from "@material-ui/core";

import DateFnsUtils from "@date-io/date-fns";

import {

  subsDaysToDate,

} from "__helpers/util";
import Scrollbars from "react-custom-scrollbars";
import { dpBaseRoutes } from "base-routes";
import { basePath } from "base-routes";
import SwitchToggle from "components/SwitchToggle/SwitchToggle";
import EditSurvey from "./EditSurvey";
import { apiPath } from "api";
import { userService } from "_services/user.service";
import { generalAuthTokenHeader } from "__helpers/auth-header";
import PatientTasks from "./PatientTasks";
import { PRIORITY_LIST } from "__helpers/constants";
import FilterComponent from "components/FilterComponent";
import { PATIENT_LIST } from "__helpers/constants";
import moment from "moment";
import { TASK_STATUS } from "__helpers/constants";
import { Close, Visibility } from "@material-ui/icons";
import PreviewSubmittedSurvey from "./PreviewSubmittedSurvey";
import editIcons from '../../../assets/img/edit.svg';
import serchIcons from '../../../assets/img/serch.svg';
import taskTemplteCss from "../../../assets/css/taskTemplte.css";
import tableCss from "../../../assets/css/table.css";
import eye from "../../../assets/img/eye-view.svg";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});
const mapStateToProps = (state) => {
  return {
    userInfoRedux: state.userInfo,
    categoryListRedux: state.categoryList,
    insuranceListRedux: state.insuranceList,
    patientStatusListRedux: state.patientStatusList,
    hospitalListRedux: state.hospitalList,
    timestampRedux: state.timestamp,
    reduxLoadFlag: state.reduxLoadFlag,
  };
};
const headCells = [


  {
    id: "patientName",
    numeric: false,
    disablePadding: false,
    sorting: true,
    label: "Patient Name",
  },
  //  {
  //     id: "assignee	",
  //     numeric: false,
  //     disablePadding: false,
  //     sorting: true,
  //     label: "Assignee	",
  //   },
  {
    id: "taskName",
    numeric: false,
    disablePadding: false,
    sorting: true,
    label: "Task Name",
  },
  {
    id: "dueDate",
    numeric: false,
    disablePadding: false,
    sorting: true,
    label: "Task Due Date",
  },
  {
    id: "taskPriority",
    numeric: false,
    disablePadding: false,
    sorting: true,
    label: "Task Priority",
  },
  {
    id: "taskStatus",
    numeric: false,
    disablePadding: false,
    sorting: true,
    label: "Task Status",
  },
  {
    id: "contactName",
    numeric: false,
    disablePadding: false,
    sorting: true,
    label: "Contact Name",
  },

  {
    id: "relationship",
    numeric: false,
    disablePadding: false,
    sorting: true,
    label: "Relationship",
  },
  {
    id: "surveyName",
    numeric: false,
    disablePadding: false,
    sorting: true,
    label: "Survey Name",
  },
  {
    id: "surveySendDate",
    numeric: false,
    disablePadding: false,
    sorting: true,
    label: "Scheduled Date",
  },
  {
    id: "surveyStatus",
    numeric: false,
    disablePadding: false,
    sorting: true,
    label: "Survey Status",
  },

  //  {
  //     id: "surveySendDate",
  //     numeric: false,
  //     disablePadding: false,
  //     sorting: true,
  //     label: "Scheduled Date",
  //   },




];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
class SurveyList extends React.Component {
  constructor(props) {
    super(props);
    let spinner = document.getElementById("loadingSpinner");
    this.dateUtility = new DateFnsUtils();
    let initialDays = 30;
    let endDate = new Date();
    let startDate = subsDaysToDate(endDate, initialDays);
    let userinfo = JSON.parse(localStorage.getItem("_user_info"));
    this.addressInputRef = React.createRef();
    this.state = {
      action: "",
      loading: false,
      templateName: "",
      taskName: "",
      taskPriority: "2",
      taskDescription: "",
      patientId: "",
      dischargePlannerId: userinfo.dischargePlanner.id,
      facilityId: userinfo.dischargePlanner.facility.facilityId,
      templateStatus: true,
      confirmModalMessage: "",


      dataId: "",
      tempaltes: [],
      surveys: [],
      showModal: false,
      selectedSurveyId: null,
      scrollInterval: null, // Interval ID for scrolling
      scrollSpeed: 10, // Speed of scrolling in pixels per interval
      //sortBy: "taskName",
      sortAsc: true,
      perPage: 10,
      total: 0,
      currentPage: 0,
      sortBy: "id",
      direction: "asc",
      spinner: spinner,
      isDelete: false,
      searchKeyword: "",
      apiPartner: "",
      formErrors: {
        taskName: "",
        templateName: "",
        taskDescription: "",
        taskPriority: "",
        tasks: [],
        tempaltes: [],
        showPreview: false,
        selectedTaskId: null,
        selectedSurvey: null
      },
      taskNameValid: false,
      templateNameValid: false,
      taskDescriptionValid: true,
      taskPriorityValid: true,
      tempaltes: [],
      taskUpdate: false,
      showHelpContent: true,

    };
    this.search = this.search.bind(this);
    this.loaderStatus = this.loaderStatus.bind(this);
    this.fetchSurveys = this.fetchSurveys.bind(this);
    this.surveyRequestId = 0; // ✅ ADD THIS

  }




  async fetchTasks() {
    this.setState({
      loading: true,
    });
    let showNotification = {};
    let url = apiPath.patientTasks + "/" + this.state.patientTaskId;
    const response = await fetch(url, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.ok) {
        } else {
          showNotification = {
            title: "Task Fetch",
            message: "Bad response from server",
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.id) {
          // let localDueDateMoment = data.dueDate
          //   ? moment
          //     .utc(data.dueDate, "YYYY-MM-DD")
          //     .format("MM/DD/YYYY")
          //   : null;

          let localDueDateString = data.dueDate
            ? this.dateUtility.format(this.parseApiDate(data.dueDate), "MM/dd/yyyy")
            : null;

          this.setState({
            loading: false,
            taskName: data.taskName,
            priority: data.taskPriority,
            description: data.taskDescription,
            changeStatus: data.changeStatus,
            notesStatus: data.statusDescription,
            //dueDate: localDueDateMoment,
            dueDate: localDueDateString,//new change
            patientTaskId: data.id,
            surveyFormId: data.surveyFormId,
            hasSurvey: data.hasSurvey,
            contactName: data.contactName,
            phoneNumber: data.phoneNumber,
            relationship: data.relationship,
            dob: data.dob,
            patientContactId: data.patientContactId,
            patientEmail: data.patientEmail,
            emailSend: data.emailSend,
            schedularDate: data.schedularDate,
            sendImmediately: "later"
          });
        } else {
          showNotification = {
            title: "Task Fetch",
            message: "Bad response from server",
            type: "danger",
          };
          this.props.updatePatientModalClose();
          this.setState({
            loading: false,
          });
        }
      })
      .catch((error) => {
        showNotification = {
          title: "Task Fetch",
          message: "Bad response from server",
          type: "danger",
        };

        this.setState({
          loading: false,
        });
        return response;
      });
    userService.showNotification(showNotification);
  }
  fetchSurveys = async (searchKeyword = "", page = this.state.currentPage) => {
    const currentRequestId = ++this.surveyRequestId;

    // Immediately set loading state and clear previous data
    this.setState({
      loading: true,
      surveys: [], // Clear old data immediately
      total: 0
    });

    this.state.spinner.removeAttribute("hidden");

    try {
      const sortDir = this.state.direction ? "asc" : "desc";
      const { dischargePlannerId, perPage, sortBy, direction, selectedFilter } = this.state;

      let url = `${apiPath.GetAllSurveyPatient}?page=${page}&size=${perPage}&sortBy=${sortBy}&orderBy=${direction}`;
      if (searchKeyword) {
        url += `&search=${encodeURIComponent(searchKeyword)}`;
      }

      if (selectedFilter) {
        Object.entries(selectedFilter).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((item) => {
              url += `&${key}=${encodeURIComponent(item)}`;
            });
          } else {
            url += `&${key}=${encodeURIComponent(value)}`;
          }
        });
      }

      const response = await fetch(url, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
        return;
      }

      const data = await response.json();

      // Only update if this is the latest request
      if (currentRequestId === this.surveyRequestId) {
        this.setState({
          surveys: data.content || [],
          total: data.totalElements || 0,
          loading: false
        });
      }
    } catch (error) {
      if (currentRequestId === this.surveyRequestId) {
        this.setState({
          surveys: [],
          total: 0,
          loading: false
        });
      }
      userService.showNotification({
        title: "Survey Fetch Error",
        message: "Unable to fetch surveys",
        type: "danger",
      });
    } finally {
      if (currentRequestId === this.surveyRequestId) {
        this.state.spinner.setAttribute("hidden", "true");
      }
    }
  };


  componentDidMount() {
    const { searchKeyword, } = this.state;

    // When component mounts, fetch surveys with existing filters/search if any
    this.setState({
      currentPage: 0,
      sortBy: 'id',
      direction: 'asc',
      surveys: [],
      total: 0
    }, () => {
      this.fetchSurveys(searchKeyword || "", 0);
    });
  }



  tableSortHandler = (property) => (event) => {
    const isAsc = this.state.sortBy === property && this.state.direction === 'asc';
    this.setState(
      {
        sortBy: property,
        direction: isAsc ? 'desc' : 'asc',
        currentPage: 0, // Reset to first page when sorting changes
      },
      () => this.fetchSurveys(this.state.searchKeyword)
    );
  };
  search = (event) => {
    const searchKeyword = event.target.value.trim();

    this.setState({ searchKeyword, currentPage: 0 }, () => {
      this.fetchSurveys(searchKeyword);
    });
  };


  handleChangePage = (event, newPage) => {
    this.setState(
      {
        currentPage: newPage,
      },
      () => this.fetchSurveys(this.state.searchKeyword)
    );
  };
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        perPage: parseInt(event.target.value),
        currentPage: 0,
      },
      () => this.fetchSurveys(this.state.searchKeyword)
    );
  };
  priorityFilterEvent = (event) => {
    const value = event.target.value;
    this.setState({ selectedPriorities: value });

    // Optional: apply filtering logic here
    // Example: this.filterByPriority(value);
  };


  fetchPatientInfo = async (patientId) => {
    try {
      if (!patientId) return;

      // Show spinner and set loading state
      this.state.spinner.removeAttribute("hidden");
      this.setState({ loading: true });

      const apiUrl = apiPath.getPatientList + "/" + patientId;

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (!response.ok) {
        if (response.status === 401) {
          userService.logout();
        } else {
          userService.showNotification({
            title: "Patient Detail",
            message: "Bad response from server",
            type: "danger",
          });
        }
        return; // Early return on error
      }

      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        this.setState({
          patientDetail: data[0],
          loading: false,
        });
      } else {
        this.setState({ loading: false });
      }
    } catch (error) {
      this.setState({ loading: false });
      userService.showNotification({
        title: "Patient Detail",
        message: "An error occurred while fetching patient info",
        type: "danger",
      });
    } finally {
      // Always hide the spinner when done (success or error)
      this.state.spinner.setAttribute("hidden", "true");
    }
  };
  handleSurveyRowClick = async (taskId, survey) => {
    const sessionPatientList = JSON.parse(sessionStorage.getItem(PATIENT_LIST)) || [];

    const matchedPatient = sessionPatientList.find(
      (patient) => patient.patientId === survey.patientId
    );

    const emailSent = survey.emailSend;

    this.setState(
      {
        openTaskModal: false,
      },
      async () => {
        await this.fetchPatientInfo(survey.patientId, matchedPatient); // ✅ Ensures patientDetail is fetched before modal opens

        setTimeout(() => {
          this.setState({
            openTaskModal: true,
            patientTaskId: taskId,
            patientDetail: this.state.patientDetail || null,
            taskName: survey.taskName || "",
            priority: survey.priority || "2",
            changeStatus: survey.changeStatus || "4",
            description: survey.description || "",
            notesStatus: survey.notesStatus || "",
            dueDate: survey.dueDate || null,
            hasSurvey: survey.hasSurvey || false,
            surveyFormId: survey.surveyFormId || null,
            contactName: survey.contactName || "",
            phoneNumber: survey.phoneNumber || "",
            relationship: survey.relationship || "",
            dob: survey.dob || "",
            patientContactId: survey.patientContactId || "",
            patientEmail: survey.patientEmail || "",
            schedularDate: survey.schedularDate || null,
            sendImmediately: survey.taskUpdate
              ? emailSent === false
                ? "later"
                : "immediate"
              : "",
            emailSend: emailSent,
            modalKey: `${taskId}-${Date.now()}`,
          });


          this.fetchTasks();    // ✅ fetchTasks depends on contactListFetched
        }, 0);
      }
    );
  };

  parseApiDate = (dateStr) => {
    if (!dateStr) return null;

    // Case 1: date-only (YYYY-MM-DD)
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      const [year, month, day] = dateStr.split("-");
      return new Date(Number(year), Number(month) - 1, Number(day));
    }

    // Case 2: datetime (YYYY-MM-DDTHH:mm:ss)
    if (/^\d{4}-\d{2}-\d{2}T/.test(dateStr)) {
      const d = new Date(dateStr);
      // normalize to local midnight
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    return new Date(dateStr); // fallback
  };

  formatDateString = (dateStr, format = "MM/dd/yyyy") => {
    if (!dateStr) return "";

    let year, month, day;

    // Case 1: It's already a Date object
    if (dateStr instanceof Date) {
      year = dateStr.getFullYear();
      month = String(dateStr.getMonth() + 1).padStart(2, "0");
      day = String(dateStr.getDate()).padStart(2, "0");
    }
    // Case 2: ISO format with timezone or time part (e.g. 2025-09-04T00:00:00Z)
    else if (typeof dateStr === "string" && dateStr.includes("T")) {
      const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!match) return "";
      [, year, month, day] = match;
    }
    // Case 3: Plain date string (e.g. 2025-09-04)
    else if (typeof dateStr === "string" && dateStr.includes("-")) {
      const [y, m, d] = dateStr.split("-");
      year = y;
      month = m.padStart(2, "0");
      day = d.padStart(2, "0");
    }
    // Case 4: Fallback (try constructing Date)
    else {
      const dateObj = new Date(dateStr);
      if (isNaN(dateObj)) return "";
      year = dateObj.getFullYear();
      month = String(dateObj.getMonth() + 1).padStart(2, "0");
      day = String(dateObj.getDate()).padStart(2, "0");
    }

    // Format output
    if (format === "yyyy-MM-dd") return `${year}-${month}-${day}`;
    if (format === "MM/dd/yyyy") return `${month}/${day}/${year}`;
    if (format === "dd/MM/yyyy") return `${day}/${month}/${year}`;

    // Default fallback
    return `${month}/${day}/${year}`;
  };

  pacificFormatDateString = (dateStr, format = "MM/dd/yyyy") => {
    if (!dateStr) return "";

    let dateObj;

    // Convert input into Date object
    if (dateStr instanceof Date) {
      dateObj = dateStr;
    } else {
      // Try parsing string (ISO or plain date)
      dateObj = new Date(dateStr);
      if (isNaN(dateObj)) return "";
    }

    // Convert to Pacific Time using Intl.DateTimeFormat
    const pacificFormatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Los_Angeles",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    const [{ value: month }, , { value: day }, , { value: year }] = pacificFormatter.formatToParts(dateObj);

    // Format output
    if (format === "yyyy-MM-dd") return `${year}-${month}-${day}`;
    if (format === "MM/dd/yyyy") return `${month}/${day}/${year}`;
    if (format === "dd/MM/yyyy") return `${day}/${month}/${year}`;

    // Default fallback
    return `${month}/${day}/${year}`;
  };


  updatePatientModalClose = () => {
    let patientList = JSON.parse(localStorage.getItem(PATIENT_LIST));

    this.setState({
      patientModalStatus: false,
      openTaskModal: false,
      patientItemList: patientList,
    }, () => {
      // ✅ Call fetchSurveys after modal state is updated
      this.fetchSurveys(this.state.searchKeyword);
    });
  };

  loaderStatus = (status) => {
    this.setState({
      loading: status,
    });
  };
  handleFilterChange = (selectedFilter) => {
    this.setState({
      selectedFilter,
      currentPage: 0 // Reset to first page when filters change
    }, () => {
      this.fetchSurveys(this.state.searchKeyword, 0); // Pass 0 to ensure first page
    });
  };
  getPriorityName = (id) => {
    const found = PRIORITY_LIST.find((p) => p.id === Number(id));
    return found ? found.name : "Unknown";
  };

  getStatusName = (id) => {
    const found = TASK_STATUS.find((s) => s.id === Number(id));
    return found ? found.name : "Unknown";
  };
  render() {
    if (this.state.openTaskModal) {
      console.log("PatientTasks Props:", {
        modalKey: this.state.modalKey,
        openTaskModal: this.state.openTaskModal,
        patientCategoryList: this.state.patientCategoryList,
        patientDetail: this.state.patientDetail,
        loaderStatus: this.loaderStatus,
        patientTaskId: this.state.patientTaskId,
        suggestedTaskName: this.state.taskName,
        hasSurvey: this.state.hasSurvey,
        taskUpdate: true,
        priority: this.state.priority,
        description: this.state.description,
        changeStatus: this.state.changeStatus,
        notesStatus: this.state.notesStatus,
        dueDate: this.state.dueDate,
        surveyFormId: this.state.surveyFormId,
        contactName: this.state.contactName,
        phoneNumber: this.state.phoneNumber,
        relationship: this.state.relationship,
        dob: this.state.dob,
        patientContactId: this.state.patientContactId,
        patientEmail: this.state.patientEmail,
        emailSend: this.state.emailSend,
        schedularDate: this.state.schedularDate,
        sendImmediately: this.state.sendImmediately,
      });
    }
    const { showPreview, selectedTaskId, selectedSurvey } = this.state;




    return (
      <div id="facility-index">

        <GridContainer>
          <Scrollbars
            //style={{ height: "600px" }}
            autoHide={false}
            universal={true}
            autoHeight={true}
            autoHeightMin={0}
            autoHeightMax={1000}
          >
            <Card className={"advert-cover"}>
              <GridItem xs={12} sm={12} md={12}>
                <CardHeader
                  color="success"
                  className={"cusCardheader cusCardTitle"}
                >
                  <h4>All Tasks</h4>
                </CardHeader>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div style={{ display: "flex", justifyContent: "space-between", paddingRight: "45px" }}>

                  <div className="search-btn-cover" style={{ margin: "5px" }}>
                    <input
                      type="text"
                      title="Search by Patient name"
                      placeholder="Search by Patient name"
                      className="search-btn"
                      onChange={this.search}
                    />
                    {/* <i className="material-icons">search</i> */}
                    <img src={serchIcons} alt="" srcset="" className="material-icons" />
                  </div>

                  <FilterComponent onFilterChange={this.handleFilterChange} />
                </div>


              </GridItem>
              <div className={"custom-container"}>
                <div className="tableResponsive">
                  <Table>
                    <TableHead>
                      <TableRow>
                        {headCells.map((headCell) => (
                          <TableCell
                            key={headCell.surveyFormId}
                            align={headCell.numeric ? "right" : "left"}
                            padding={
                              headCell.disablePadding ? "none" : "default"
                            }
                          >
                            {headCell.sorting ? (
                              <TableSortLabel
                                active={this.state.sortBy == headCell.id}
                                direction={this.state.direction}
                                onClick={this.tableSortHandler(headCell.id)}
                              >
                                {headCell.label}
                              </TableSortLabel>
                            ) : (
                              headCell.label
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    {this.state.surveys.length ? (
                      this.state.surveys.map((survey, index) => (
                        <TableRow
                          key={survey.surveyFormId}
                          onClick={() => this.handleSurveyRowClick(survey.taskId, survey)}
                          style={{ cursor: "pointer" }}
                        >
                          <TableCell>{survey.patientName || "-"}</TableCell>
                          {/* <TableCell>{survey.assignee	 || "-"}</TableCell> */}
                          <TableCell>
                            <Tooltip title={survey.taskName || "-"} arrow>
                              <div style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: 150, // adjust width as needed
                              }}>
                                {survey.taskName || "-"}
                              </div>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            {/* {survey.dueDate
                                ? this.dateUtility.format(new Date(survey.dueDate), "MM/dd/yyyy")
                                : "-"} */}
                            {survey.dueDate
                              ? this.dateUtility.format(this.parseApiDate(survey.dueDate), "MM/dd/yyyy")
                              : "-"}
                          </TableCell>
                          <TableCell>{this.getPriorityName(survey.taskPriority || "-")}</TableCell>
                          <TableCell>{this.getStatusName(survey.taskStatus || "-")}</TableCell>
                          <TableCell>{survey.contactName || "-"}</TableCell>

                          <TableCell>{survey.relationship || "-"}</TableCell>
                          <TableCell>{survey.surveyName || "-"}</TableCell>
                          <TableCell>
                            {/* {survey.surveySendDate
                                ? this.dateUtility.format(new Date(survey.surveySendDate), "MM/dd/yyyy")
                                : "-"} */}

                            {/* {survey.surveySendDate
                                ?  this.dateUtility.format(
                                this.parseApiDate(survey.surveySendDate), "MM/dd/yyyy")
                                : "-"}  */}

                            {survey.surveySendDate
                                ?  this.formatDateString(survey.surveySendDate, "MM/dd/yyyy")
                                : "-"} 


                            {/* {survey.surveySendDate
                              ? this.pacificFormatDateString(survey.surveySendDate, "MM/dd/yyyy")
                              : "-"} */}
                          </TableCell>
                          <TableCell>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <span
                                style={{
                                  fontWeight: "bold",
                                  color:
                                    survey.surveyStatus === "SUBMITTED"
                                      ? "#3D9F40"
                                      : survey.surveyStatus === "DELIVERED"
                                        ? "#2D87EE"
                                        : survey.surveyStatus === "VIEWED"
                                          ? "#F57649"
                                          : "",
                                }}
                              >
                                {survey.surveyStatus || "-"}
                              </span>

                              {survey.surveyStatus === "SUBMITTED" && (
                                <img
                                  src={eye}
                                  alt="preview"
                                  className="material-icons"
                                  key={survey.taskId || index}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({
                                      showPreview: true,
                                      selectedTaskId: survey.taskId,
                                      selectedSurvey: survey,
                                    });
                                  }}
                                  style={{ cursor: "pointer", paddingLeft: "5px" }}
                                />
                              )}
                            </div>
                          </TableCell>

                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan="10">
                          <div className="not-found-text" style={{ textAlign: "center" }}>Surveys not found</div>
                        </TableCell>
                      </TableRow>
                    )}


                  </Table>
                </div>
                <TablePagination
                  rowsPerPageOptions={PER_PAGE_OPTIONS}
                  component="div"
                  count={this.state.total}
                  rowsPerPage={this.state.perPage}
                  page={this.state.currentPage}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </div>
            </Card>
          </Scrollbars>
        </GridContainer>
        {this.state.openTaskModal && (
          <PatientTasks
            key={this.state.modalKey}
            openTaskModal={this.state.openTaskModal}
            updatePatientModalClose={this.updatePatientModalClose}
            patientCategoryList={this.state.patientCategoryList}
            patientDetail={this.state.patientDetail}
            loaderStatus={this.loaderStatus}
            patientTaskId={this.state.patientTaskId}
            suggestedTaskName={this.state.taskName}
            hasSurvey={this.state.hasSurvey}
            taskUpdate={true}
            priority={this.state.priority}
            description={this.state.description}
            changeStatus={this.state.changeStatus}
            notesStatus={this.state.notesStatus}
            dueDate={this.state.dueDate}
            surveyFormId={this.state.surveyFormId}
            contactName={this.state.contactName}
            phoneNumber={this.state.phoneNumber}
            relationship={this.state.relationship}
            dob={this.state.dob}
            patientContactId={this.state.patientContactId}
            patientEmail={this.state.patientEmail}
            emailSend={this.state.emailSend}
            schedularDate={this.state.schedularDate}
            sendImmediately={this.state.sendImmediately}
          />
        )}
        <Dialog
          open={showPreview}
          onClose={() => this.setState({ showPreview: false })}
          maxWidth="md"
          fullWidth
          scroll="paper"
        >
          <DialogTitle>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ flex: 1 }}> Preview Submitted Survey</div>
              <IconButton
                onClick={() => this.setState({ showPreview: false })}
                color="inherit"
                aria-label="close"
                edge="end"
              >
                <Close />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            {showPreview && (
              <PreviewSubmittedSurvey
                key={selectedTaskId}
                taskId={selectedTaskId}
                survey={selectedSurvey}
              />
            )}
          </DialogContent>
        </Dialog>

      </div>
    );
  }
}
export default SurveyList;
